import { adminFetch } from "./base";
import type { DashboardData, ChartData } from "./types";

interface DateRangeParams {
  readonly from: Date;
  readonly to: Date;
}

function buildRangeQuery({ from, to }: DateRangeParams): string {
  return `from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`;
}

/** Admin dashboard endpoints. */
export const dashboardApi = {
  /** Fetch top-level KPIs scoped to the given date range. */
  get: (range: DateRangeParams) =>
    adminFetch<DashboardData>(`/api/admin/dashboard?${buildRangeQuery(range)}`),

  /** Fetch chart data for the given date range. */
  getCharts: (range: DateRangeParams) =>
    adminFetch<ChartData>(`/api/admin/dashboard/charts?${buildRangeQuery(range)}`),
} as const;
